<template>
  <div id='page_Container'>
        <div id="main-container" class='main-container'>
            <div id="after-sales-details">
                <header>
                    <div class="status">{{applyInfo.model && applyInfo.model.appointmentStatusDesc}}</div>
                    <div class="datetime">{{applyInfo.model && applyInfo.model.updateTime}}</div>
                </header>
                <div class="pro">
                    <div class="pro-img">
                        <img :src="productInfo.productImg" alt="">
                    </div>
                    <div class="pro-info">
                        <div class="pro-title">{{productInfo.productName}}</div>
                        <div class="pro-sku">{{productInfo.specificationValue}}</div>
                    </div>
                </div>
                <div class="apply-info">
                    <InfoShow :formObj="applyInfo"></InfoShow>
                </div>
                <div class="work-order-info" v-if="workShow">
                    <InfoShow :formObj="workOrderInfo"></InfoShow>
                </div>
                <div class="cancel-btn">
                    <van-button size="large" type="primary" round @click="cancelApply" v-if="btnShow" :disabled="btnDisabled">取消申请</van-button>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
export default {
    data() {
        return {
            btnShow: false,
            loading: false,
            btnDisabled: false,
            afterSalesType: this.$route.query.type,
            appointId: this.$route.query.appointId,
            afterSalesTypeDesc: '安装',
            productInfo: {
                productName: '',
                productImg: '',
                specificationValue: ''
            },
            applyInfo: {
                labelWidth: '65px',
                model: {
                    // quantity: 0,
                    // appointmentTime: '',
                    // appointmentAddress: '',
                    // accountName: '',
                    // accountPhone: '',
                    // remark: '',
                    // photo: []
                },
                data: []
            },
            workShow: false,
            workOrderInfo: {
                labelWidth: '65px',
                model: {
                },
                data: []
            }

        };
    },
    esvShow() {
        this.afterSalesType = this.$route.query.type;
        this.appointId = this.$route.query.appointId;
        const { productName, productImg, specificationValue } = this.choiceGoodsItem;
        console.log(this.choiceGoodsItem, 'choiceGoodsItem', productName, productImg, specificationValue);
        console.log(this.$store.state.order.choiceGoodsItem);

        this.productInfo = {
            productName,
            productImg,
            specificationValue
        };
        this.afterSalesTypeDesc = this.afterSalesType === 'install' ? '安装' : '维修';

        this.queryAppointRecordAndWorkOrder({ appointId: this.appointId });
    },
    methods: {
        ...mapMutations(['changeChoiceGoodsItem']),
        queryAppointRecordAndWorkOrder(params) {
            this.$doRequest(
                {
                    url: '/appoint/queryAppointRecordAndWorkOrder',
                    params: params,
                    before: () => {
                        this.loading = toastLoading();
                    },
                    complete: () => {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    const appointmentTime = data.result.appointmentRecord.appointmentTime.split(' ')[0] + ' ' + data.result.appointmentRecord.appointmentTimeQuantumDesc;
                    this.$set(this.applyInfo, 'model', { ...data.result.appointmentRecord, quantity: this.choiceGoodsItem.quantity, appointmentTime });
                    if (data.result.workOrder) {
                        this.workShow = true;
                        this.workOrderInfo.model = { ...data.result.workOrder, appointmentTime };
                        this.workOrderInfo.data = [
                            // 预约时间：2020-02-10 12:12:32
                            { label: '工单编号：', enName: 'workOrderCode' },
                            { label: '外勤编号：', enName: 'outsideMemberNo' },
                            { label: '外勤员：', enName: 'outsideMemberName' },
                            { label: '外勤电话：', enName: 'outsideMemberPhone', type: 'phone' },
                            { label: '工单说明：', enName: 'failReason' },
                            { label: '申请时间：', enName: 'createTime' },
                            { label: '预约时间：', enName: 'appointmentTime' },
                            { label: '派工时间：', enName: 'dispatchTime' },
                            { label: '完成时间：', enName: 'updateTime' }
                        ];
                    }
                    const applyInfoData = [
                        { label: `${this.afterSalesTypeDesc}数量：`, enName: 'quantity' },
                        { label: `${this.afterSalesTypeDesc}时间：`, enName: 'appointmentTime' },
                        { label: `${this.afterSalesTypeDesc}地址：`, enName: 'appointmentAddress' },
                        { label: '联系人：', enName: 'accountName' },
                        { label: '联系电话：', enName: 'accountPhone' },
                        { label: '备注：', enName: 'remark' }
                    ];
                    if (this.afterSalesType !== 'install') {
                        this.applyInfo.model.images = this.applyInfo.model.images ? this.applyInfo.model.images.split(',') : [];
                        applyInfoData.push({ label: '照片：', enName: 'images', type: 'photo' });
                    }
                    this.$set(this.applyInfo, 'data', applyInfoData);
                    this.btnShow = data.result.appointmentRecord.appointmentStatus !== 50;
                }
            );
        },
        cancelApply() {
            this.cancelAppointRecord({ id: this.appointId });
        },
        cancelAppointRecord(params) {
            this.$doRequest(
                {
                    url: '/appoint/cancelAppointRecord',
                    params: params,
                    before: () => {
                        this.loading = toastLoading();
                    },
                    complete: () => {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    this.changeChoiceGoodsItem({ statusName: 'serviceFlag', status: 2 });
                    this.queryAppointRecordAndWorkOrder({ appointId: this.appointId });
                    this.$toast('取消申请成功');
                },
                (data) => {
                    this.$toast(data.message);
                }
            );
        }
    },
    computed: {
        ...mapState({ choiceGoodsItem: state => state.order.choiceGoodsItem })
    },
    components: {
        InfoShow: () => import('@/components/common/infoShow/infoShow')
    }
};
</script>

<style lang="scss">
    #after-sales-details {
        img {
            width: 100%;
            height: 100%;
        }
        header{
            background-image: linear-gradient(-90deg, #EF4274 0%, #EE3556 100%);
            color: #fff;
            padding: 12px 16px;
            .status {
                font-size: 18px;
            }
        }
        .pro {
            padding: 12px;
            margin-bottom: 8px;
            display: flex;
            &-img {
                width: 80px;
                height: 80px;
                flex: none;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            &-info {
                padding-left: 12px;
                >div {
                    height: 40px;
                    line-height: 20px;
                    @include textoverflow
                }
            }
            &-title {

            }
            &-sku {
                color: #999;
            }
        }
        .apply-info, .work-order-info {
            background-color: #fff;
            padding: 12px;
        }
        .apply-info {
            margin-bottom: 16px;
        }
        .cancel-btn {
            margin: 30px 24px 0;
        }
    }
</style>
